.foundationField {
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 12px;
  justify-content: start;

  @media screen and (width >= 769px) {
    gap: 24px;
  }
}

.container {
  display: grid;
  gap: 8px;
  height: min-content;

  @media screen and (width >= 600px) {
    width: min-content;
  }
}

.inputContainer {
  display: grid;
  grid-template-columns: auto auto;
  gap: 12px;
  align-items: center;
  font-size: var(--font-size-xs);

  @media screen and (width >= 769px) {
    gap: 24px;
  }
}

.inputWrapper {
  width: 82px;

  input {
    width: 100%;
  }
}
